<div class="compose-wrapper {{ isIE ? 'ie' : '' }}">
	<div class="compose-message">
		<h2 class="m-ttile mb-3" [translate]="'messaging.compose.new-message'">New Message</h2>
		<form [formGroup]="composeMessageForm">
			<div class="row mb-3">
				<div class="col-2 d-flex align-items-center">
					<strong [translate]="'messaging.compose.to'">To:</strong>
				</div>
				<div class="col-md-6 message-input-box to">
					<mat-form-field class="w-100">
						<mat-label>Please Select</mat-label>
						<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="toReceiverType">
							<mat-option [value]="'3'">
								<span [translate]="'messaging.compose.coach'">Health Coaching</span>
							</mat-option>
							<mat-option [value]="'5'">
								<span [translate]="'messaging.compose.ehe-referral'">EHE Referral Program</span>
							</mat-option>
						</mat-select>
						<mat-error>
							<app-error-message [control]="'toReceiverType'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col-2 d-flex align-items-center">
					<strong [translate]="'messaging.compose.subject'">Subject:</strong>
				</div>
				<div class="col-md-8">
					<mat-form-field class="w-100">
						<input matInput formControlName="msgSubject" autocomplete="off" />
						<mat-error>
							<app-error-message [control]="'msgSubject'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-md-10">
					<div class="NgxEditor__Wrapper">
						<ngx-editor-menu id="msgBody" [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
						<ngx-editor
							[editor]="editor"
							[ngModel]="html"
							[disabled]="false"
							formControlName="msgBody"
							[placeholder]="'Enter text here...'"></ngx-editor>
						<app-error-message [control]="'msgBody'"></app-error-message>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-10">
					<div class="button-group-right">
						<button class="button" mat-button appEheAnalytics [data]="analyticsData" (click)="sendMessage()">
							<span [translate]="'messaging.message.send-button'">SEND</span>
						</button>
						<button
							class="button secondary-btn button-medium mat-stroked-button"
							mat-button
							appEheAnalytics
							[data]="analyticsData"
							(click)="cancelSendMessage()">
							<span [translate]="'messaging.message.cancel-button'">CANCEL</span>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
